"use client";

import React, { useState, useRef, useEffect } from "react";
import dynamic from "next/dynamic";
import * as ReactDOM from "react-dom";
import { X } from "lucide-react";
import FilterBar from "@/app/cin_booking_engine/Filterbar";
import { BookingEngineProvider } from "@/app/cin_context/BookingEngineContext";

// dynamic imports
const ExperienceSection = dynamic(
  () => import("@/components/ExperienceSection"),
  { ssr: false }
);
const ExploreSection = dynamic(() => import("@/components/ExploreSection"), {
  ssr: false,
});
const Header = dynamic(() => import("@/components/Header"), { ssr: false });

export default function BrandHomePage({ contentData, tokenKey }) {
  const [isOpen, setOpen] = useState(false);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const filterBarRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isOpenFilterBar, openFilterBar] = useState(false);
  const [staahPropertyId, setStaahPropertyId] = useState(null);
  const [cityDetails, setCityDetails] = useState(null);

  const handlePropertyBookNow = async (prperty) => {
    if (window.innerWidth < 768) {
      setOpen(!isOpen);
      setShowFilterBar(!showFilterBar);
    }
    const label = prperty?.cityName;
    const value = prperty?.cityId;
    const property_Id = prperty?.staahPropertyId;
    setCityDetails({ label, value, property_Id });
    setStaahPropertyId(prperty?.staahPropertyId);

    if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      const firstInput = filterBarRef.current.querySelector(
        "input, select, button"
      );
      if (firstInput) firstInput.focus();
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setShowFilterBar(window.innerWidth >= 768);
      setIsMobile(window.innerWidth < 768);
    }
  }, []);

  useEffect(() => {
    if (tokenKey) {
      openFilterBar(!isOpenFilterBar);
    }
  }, [tokenKey]);

  const brandColors = {
    1: "#bf1e2d",
    7: "#bf1e2d",
    2: "#263997",
    3: "#f04e02",
    4: "#9900cc",
    8: "#febb19",
    9: "#f9e12e",
  };

  return (
    <>
      <Header
        onClick={handlePropertyBookNow}
        brandId={2}
        brandColor="#263997"
      />
      <section ref={filterBarRef} className="position-relative">
        <div className="banner-bg"></div>
        <section className="booking-form-section">
          {isMobile && (
            <div
              className={`booking-search-bar-btn-div home-page-class`}
              style={{ zIndex: 10 }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handlePropertyBookNow();
                }}
                className="booking-toggle-btn"
              >
                {isOpen ? <X size={18} color="black" /> : "Book Now"}
              </button>
            </div>
          )}
          {isOpenFilterBar && typeof window !== "undefined" &&
            ReactDOM.createPortal(
              <BookingEngineProvider>
                <FilterBar
                  contentData={contentData}
                  tokenKey={tokenKey}
                  selectedProperty={0}
                  openBookingBar={isOpenFilterBar}
                  onClose={() => {
                    openFilterBar(false);
                    setOpen(false);
                  }}
                  isShowSelectedBrand={true}
                  selectedBrand="Kyriad Hotel" 
                />
              </BookingEngineProvider>,
              document.body
            )}

          {showFilterBar && typeof window !== "undefined" &&
            ReactDOM.createPortal(
              <BookingEngineProvider>
                <FilterBar
                  selectedProperty={parseInt(staahPropertyId)}
                  cityDetails={cityDetails}
                  openBookingBar={showFilterBar}
                  onClose={(isReload) => {
                    if (window.innerWidth < 768) {
                      setOpen(!isOpen);
                      setShowFilterBar(!showFilterBar);
                    }
                    if (isReload) {
                      window.location.reload();
                    }
                  }}
                  backgroundColor="#263997"
                  isShowSelectedBrand={true}
                  selectedBrand="Kyriad Hotel"  
                />
              </BookingEngineProvider>,
              document.body
            )}
        </section>
      </section>

      <ExploreSection onClick={handlePropertyBookNow} brandPageColor="#263997" brandPageId={2} />
      <section className="mb-4 mt-4">
        <ExperienceSection onClick={handlePropertyBookNow} brandPageId={2} brandPageColor="#263997"/>
      </section>

      <style jsx>{`
        .banner-bg {
          background-image: url("/images/banner.png");
          height: 100vh;
          background-size: cover;
          background-position: center;
        }

        .banner-video-wrapper {
          position: relative;
          width: 100%;
          height: 100vh;
          overflow: hidden;
        }

        .banner-video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* Show desktop video only on screens ≥ 768px */
        .desktop-video {
          display: block;
        }

        .mobile-video {
          display: none;
        }

        @media (max-width: 768px) {
          .desktop-video {
            display: none;
          }
          .mobile-video {
            display: block;
          }
        }
      `}</style>
    </>
  );
}
